import React from 'react';
import Menu from '../myComponents/Menu';
import './SetupMainPage.css';
import Footer from '../myComponents/Footer';
import { Link } from 'react-router-dom';

import { 
  BsDownload, 
  BsPhone, 
  BsWifi,
  BsShield,
  BsLock,
  BsLightning
} from "react-icons/bs";
import { 
  FaWindows, 
  FaApple, 
  FaLinux, 
  FaAndroid 
} from "react-icons/fa";

const SetupMainPage = () => {
  const platforms = [
    {
      name: "iOS",
      description: "iPhone, iPad",
      icon: <BsPhone />,
      path: "/setup/ios",
      apps: ["Happ", "Hiddify", "V2Box"],
      difficulty: "Легко"
    },
    {
      name: "Android",
      description: "Смартфоны и планшеты",
      icon: <FaAndroid />,
      path: "/setup/android",
      apps: ["V2RayNG", "Hiddify", "Clash"],
      difficulty: "Легко"
    },
    {
      name: "Windows",
      description: "Компьютеры и ноутбуки",
      icon: <FaWindows />,
      path: "/setup/windows",
      apps: ["V2RayN", "Clash", "Hiddify"],
      difficulty: "Легко"
    },
    {
      name: "macOS",
      description: "MacBook, iMac",
      icon: <FaApple />,
      path: "/setup/ios",
      apps: ["ClashX", "V2RayU", "Hiddify"],
      difficulty: "Легко"
    },
    {
      name: "Linux",
      description: "Ubuntu, Debian и другие",
      icon: <FaLinux />,
      path: "/setup/linux",
      apps: ["V2Ray", "Clash", "Hiddify"],
      difficulty: "Средне"
    },
    {
      name: "Роутер",
      description: "OpenWrt, Padavan",
      icon: <BsWifi />,
      path: "/setup/router",
      apps: ["OpenWrt", "Padavan", "Merlin"],
      difficulty: "Сложно"
    }
  ];

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case "Легко": return "#00ff00";
      case "Средне": return "#ffaa00";
      case "Сложно": return "#ff4444";
      default: return "#fff";
    }
  };

  return (
    <div className="App">
      <div style={{ position: 'relative', zIndex: 1000 }}>
        <Menu />
      </div>
      
      <section className="setup-main-section">
        <div className="setup-main-container">
          {/* Header */}
          <div className="setup-main-header">
            <h1 className="setup-main-title">Инструкции по настройке</h1>
            <p className="setup-main-description">
              Выберите вашу операционную систему или устройство для получения 
              подробной инструкции по установке RED BUTTON VPN.
              <br/><br/>
              Все инструкции содержат пошаговые руководства с скриншотами 
              и ссылками на необходимые приложения.
            </p>
          </div>

          {/* Quick Start */}
          <div className="quick-start-section">
            <h2><BsLightning /> Быстрый старт</h2>
            <div className="quick-start-cards">
              <div className="quick-card most-popular">
                <div className="quick-card-badge">Самое популярное</div>
                <div className="quick-card-icon"><BsPhone /></div>
                <h3>iPhone / iPad</h3>
                <p>Простая установка за 2 минуты</p>
                <Link to="/setup/ios" className="quick-card-btn">
                  Начать настройку
                </Link>
              </div>
              
              <div className="quick-card">
                <div className="quick-card-icon"><FaAndroid /></div>
                <h3>Android</h3>
                <p>Бесплатные приложения</p>
                <Link to="/setup/android" className="quick-card-btn">
                  Начать настройку
                </Link>
              </div>
              
              <div className="quick-card">
                <div className="quick-card-icon"><FaWindows /></div>
                <h3>Windows</h3>
                <p>Для компьютеров</p>
                <Link to="/setup/windows" className="quick-card-btn">
                  Начать настройку
                </Link>
              </div>
            </div>
          </div>

          {/* All Platforms */}
          <div className="platforms-section">
            <h2><BsShield /> Все платформы</h2>
            <div className="platforms-grid-setup-page">
              {platforms.map((platform, index) => (
                <Link 
                  key={index} 
                  to={platform.path} 
                  className="platform-card"
                >
                  <div className="platform-card-header">
                    <div className="platform-icon">{platform.icon}</div>
                    <div className="platform-info">
                      <h3 className="platform-name">{platform.name}</h3>
                      <p className="platform-description">{platform.description}</p>
                    </div>
                    <div 
                      className="difficulty-badge"
                      style={{ color: getDifficultyColor(platform.difficulty) }}
                    >
                      {platform.difficulty}
                    </div>
                  </div>
                  
                  <div className="platform-apps">
                    <span className="apps-label">Приложения:</span>
                    <div className="apps-list">
                      {platform.apps.map((app, appIndex) => (
                        <span key={appIndex} className="app-tag">
                          {app}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="platform-arrow">→</div>
                </Link>
              ))}
            </div>
          </div>

          {/* Help Section */}
          <div className="help-section">
            <div className="help-card">
              <h2><BsLock /> Нужна помощь?</h2>
              <p>
                Если у вас возникли проблемы с настройкой, обратитесь в нашу 
                техническую поддержку через Telegram-бот.
              </p>
              <div className="help-buttons">
                <a href="https://t.me/redbutton_vpn_bot" target="_blank" rel="noopener noreferrer" className="help-btn primary">
                  Написать в поддержку
                </a>
                <button 
  className="help-btn secondary"
  onClick={() => {
    window.location.href = '/#/';
    setTimeout(() => {
      document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
    }, 200);
  }}
>
  Частые вопросы
</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default SetupMainPage;